(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery/dist/jquery.slim"), require("popper.js"));
	else if(typeof define === 'function' && define.amd)
		define([, ], factory);
	else if(typeof exports === 'object')
		exports["__storefrontTwbs"] = factory(require("jquery/dist/jquery.slim"), require("popper.js"));
	else
		root["__storefrontTwbs"] = factory(root["$"], root["Popper"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__3__) {
return 